/**
 * Generates a data URI for a placeholder avatar image.
 * Uses an inline SVG to avoid external network dependencies.
 * This ensures mocks work offline and don't rely on third-party services.
 */
const createPlaceholderAvatarDataUri = (): string => {
  // Simple SVG placeholder: warm-toned background with a person icon
  const svg = `<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" fill="#f0d4b5"/><circle cx="100" cy="80" r="30" fill="#c8966a"/><path d="M 50 140 Q 50 120 100 120 Q 150 120 150 140 L 150 200 L 50 200 Z" fill="#c8966a"/></svg>`;
  // URL-encode SVG for data URI (works in all environments, no Buffer needed)
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const profileAvatarMock = {
  id: 'avatar-123',
  image128Url: createPlaceholderAvatarDataUri(),
  __typename: 'ProfileAvatar',
};

export const avatarMockOverrides = {
  ProfileAvatar: () => profileAvatarMock,
};
